<mat-accordion class="expantion-style">
    <mat-expansion-panel class="mat-expansion-panel" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="title">検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div formGroupName="cndt">
            <div class="tw-flex tw-flex-row" style="width: 600px;">
                <mat-form-field appearance="outline"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
                    <mat-label>会社</mat-label>
                    <mat-select id="companycode" formControlName="companycode" (valueChange)="onChangeCompany($event)">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let div of companycodeList" [value]="div.value">{{div.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline"
                    class="input-form-select tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
                    <mat-label>地区</mat-label>
                    <mat-select id="pressTantoAreacode" formControlName="pressTantoAreacode">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let div of areaCodeList" [value]="div.value">{{div.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="tw-flex tw-flex-row" style="width: 600px;">
                <mat-form-field appearance="outline"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%]">
                    <mat-label>料金区分</mat-label>
                    <mat-select id="pressmoneyDivcd" formControlName="pressmoneyDivcd">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let div of pressmoneyDivcdList" [value]="div.value">{{div.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center tw-gap-1.5"
            style="display:flex;">
            <mat-card-actions class="btn_area_right expansion-panel-actions">
                <button type="submit" [disabled]="searchConditionForm.invalid" mat-raised-button color="primary"
                    class="btn" id="search">検索</button>
            </mat-card-actions>
            <mat-card-actions class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()"
                    id="clear">クリア</button>
            </mat-card-actions>
        </div>
    </mat-expansion-panel>
</mat-accordion>